<template>
  <div class="main-panel-container">
    <div
      class="cell cell-img van-hairline--bottom"
      @click="orderItemDetail(data.items)"
    >
      <div class="img-list">
        <div
          v-for="(item, index) in data.items"
          :key="data.orderNo + index"
          v-show="index < 3"
          class="img"
          :style="{
            backgroundImage: 'url(' + item.goodsInfoImg + ')',
          }"
        ></div>
        <div class="more" v-show="data.goodsInfo && data.goodsInfo.length > 3">
          …
        </div>
      </div>
      <div class="status">
        <span class="value">共{{ data.items ? data.items.length : 0 }}件</span>
        <img :src="require('@/assets/setting/箭头.svg')" alt="" />
      </div>
    </div>
    <div v-show="data.needInvoice" class="cell cell-img van-hairline--bottom">
      <div class="label text-sm">发票信息</div>
      <div class="status">
        <div
          class="value"
          @click="
            $router.push({
              name: 'InSaleInvoiceSimple',
              query: {
                id: data.orderNo,
                companyName: data.invoiceDemand.companyName,
                taxpayerNumber: data.invoiceDemand.taxpayerNumber,
                companyPhone: data.invoiceDemand.companyPhone,
                companyAddress: data.invoiceDemand.companyAddress,
                bankNo: data.invoiceDemand.bankNo,
                bankName: data.invoiceDemand.bankName,
                businessLicenceImg: data.invoiceDemand.businessLicenceImg,
                taxpayerIdentificationImg:
                  data.invoiceDemand.taxpayerIdentificationImg,
              },
            })
          "
        >
          增值税发票<img
            class="inline-block"
            :src="require('@/assets/setting/箭头.svg')"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="van-hairline--bottom pr-3">
      <Field
        rows="1"
        autosize
        input-align="right"
        type="textarea"
        v-model="data.buyerRemarks"
        label="订单备注"
        placeholder="点此输入订单备注(100字以内)"
      />
    </div>
    <div class="cell cell-default van-hairline--bottom">
      <div class="label">支付方式</div>
      <div class="value">{{ data.payChannel }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ImagePreview, Field } from 'vant'
export default {
  components: { Field },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      returnOrderAppealReason: (state) => state.options.returnOrderAppealReason,
    }),
  },
  filters: {
    status_f(val, list) {
      const i = list.find((item) => item.value === val)
      return (i && i.label) || ''
    },
  },
  methods: {
    imagePreview(startPosition, list) {
      ImagePreview({
        images: list,
        startPosition,
      })
    },
    orderItemDetail(data) {

      this.$router.push({
        name: 'OrderInSaleGoodsDetail',
        query: { id: this.data.orderNo, data: JSON.stringify(data) },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main-panel-container {
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
  padding: 0 0 0 32px;
  .cell {
    padding: 32px 52px 32px 32px;
  }
  .cell-img {
    display: flex;
    justify-content: space-between;
    .img-list {
      display: flex;
      .img {
        width: 128px;
        height: 128px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 12px;
      }
    }
    .status {
      display: flex;
      font-size: 28px;
      line-height: 28px;
      align-items: center;
      span {
        font-size: 28px;
        line-height: 28px;
      }
      img {
        height: 23px;
        margin-left: 24px;
      }
    }
  }
  .cell-default {
    display: flex;
    justify-content: space-between;
    .label {
      font-size: 28px;
      line-height: 28px;
    }
    .value {
      font-size: 28px;
      color: #999999;
      line-height: 28px;
    }
  }
  .cell-affix {
    .label {
      font-size: 28px;
      line-height: 28px;
    }
    .img-list {
      display: flex;
      padding-top: 20px;
      .img {
        width: 144px;
        height: 144px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 12px;
      }
    }
  }
}
</style>
